import { Injectable } from '@angular/core';

@Injectable()
export class ModalService {
  toggleMakePaymentComponent: boolean;
  toggleActivateDigitalAccessComponent: boolean;
  togglePaymentHistoryComponent: boolean;
  toggleChangeCollectionTypeComponent: boolean;
  toggleScheduleVacationComponent: boolean;

  constructor() {
    this.toggleMakePaymentComponent = false;
    this.toggleActivateDigitalAccessComponent = false;
    this.togglePaymentHistoryComponent = false;
    this.toggleChangeCollectionTypeComponent = false;
    this.toggleScheduleVacationComponent = false;
  }

  toggle(componentName) {
    switch(componentName) { 
        case 'activate-digital-access': { 
           this.toggleActivateDigitalAccessComponent = !this.toggleActivateDigitalAccessComponent; 
           break; 
        } 
        case 'make-payment': { 
           this.toggleMakePaymentComponent = !this.toggleMakePaymentComponent;
           break; 
        }
        case 'payment-history': { 
          this.togglePaymentHistoryComponent = !this.togglePaymentHistoryComponent;
          break; 
       }
       case 'change-collection-type': { 
        this.toggleChangeCollectionTypeComponent = !this.toggleChangeCollectionTypeComponent;
        break; 
       }
       case 'schedule-vacation': { 
        this.toggleScheduleVacationComponent = !this.toggleScheduleVacationComponent;
        break; 
       }
        default: { 
           break; 
        } 
     } 
  }

}



// WEBPACK FOOTER //
// /codebuild/output/src4156872633/src/src/app/services/modals.service.ts